"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DevInfoPanel = void 0;
var _mui = require("@ori-ui/mui");
var _CopyToClipBoard = require("./CopyToClipBoard");
var _jsxRuntime = require("react/jsx-runtime");
const formatValue = value => {
  if (typeof value === 'object' && value !== null) {
    return JSON.stringify(value, null, 2);
  }
  return String(value);
};
const DevInfoPanel = ({
  developmentInfo
}) => {
  if (!developmentInfo) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "body2",
      color: "text.secondary",
      children: "No development info available."
    });
  }
  const filteredEntries = Object.entries(developmentInfo).filter(([, value]) => value !== undefined && value !== null && value !== '');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      gutterBottom: true,
      variant: "subtitle1",
      children: "Development Info:"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Divider
    // eslint-disable-next-line react/forbid-component-props -- No need to optimize on error page
    , {
      sx: {
        mb: 2,
        borderColor: '#444'
      }
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      container: true,
      spacing: 1,
      children: filteredEntries.map(([key, value]) => {
        const label = key.replaceAll(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
        const valueToDisplay = formatValue(value);
        return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
          // eslint-disable-next-line react/forbid-component-props -- No need to optimize on error page
          sx: {
            display: 'flex',
            width: '100%',
            borderBottom: '1px solid #333',
            py: 0.5
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
            size: 4,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
              variant: "body1",
              textAlign: "left",
              children: label
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
            size: 8,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
              variant: "body1"
              // eslint-disable-next-line react/forbid-component-props -- No need to optimize on error page
              ,
              sx: {
                color: 'text.secondary',
                display: 'flex',
                flexWrap: 'wrap',
                wordBreak: 'break-all'
              },
              textAlign: "left",
              gap: 2,
              display: "flex",
              alignItems: "center",
              children: [valueToDisplay, /*#__PURE__*/(0, _jsxRuntime.jsx)(_CopyToClipBoard.CopyToClipboard, {
                text: valueToDisplay
              })]
            })
          })]
        }, key);
      })
    })]
  });
};
exports.DevInfoPanel = DevInfoPanel;
